import { init as initApm } from '@elastic/apm-rum';
import config from './config';

// Elastic RUM, same server and shape as the other Kompare funnels (ao-checkout,
// dzo-webshop). Captures page loads, route changes (ApmRoutes in main.router.tsx),
// every XHR/fetch with its status code, unhandled errors, and whatever we
// captureError() ourselves (captcha lifecycle in common/utils/captchaTelemetry.util.ts).
// Disabled in local development; `environment` is derived from the host TLD in
// config.tsx (production | work | pw | …), so it doubles as the deploy target.
//
// Deliberately NO distributedTracingOrigins: property-api runs no APM agent, so a
// traceparent header buys nothing and would turn every createSo POST into a
// CORS-preflighted request — the very call the captcha flow retries. serverUrl is
// host-dependent (config.tsx): dev hosts report to the dev APM stack, .hr to production.
// The page origin must be in rum.allow_origins of the server it reports to (prod:
// ConfigMap apm-server-config, ns default; dev: ~/dev-server-claude/elastic-dev) or every
// beacon is a silent 403.
const apm = config.REACT_APP_ENVIRONMENT !== 'development'
  ? initApm({
    serviceName: 'property-webshop',
    serverUrl: config.REACT_APP_APM_SERVER_URL,
    environment: config.REACT_APP_ENVIRONMENT,
    serviceVersion: __APP_VERSION__,
    breakdownMetrics: true,
    // session.id + sequence on the page-load transaction (sessionStorage, 30 min idle
    // timeout). Custom captcha transactions are stitched by their own `challenge_id`
    // label instead — the agent does not stamp session.id on those.
    session: true,
  })
  : undefined;

// Third-party scripts on the page (GTM, CookieYes, VWO) throw opaque cross-origin
// "Script error." — the bulk of RUM error volume on the CRM frontends is that one
// line. The agent has no ignoreErrors option, so drop them in the outgoing payload.
const IGNORED_ERROR_MESSAGES = [/^Script error\.?$/, /ResizeObserver loop/];

apm?.addFilter((payload) => {
  if (Array.isArray(payload?.errors)) {
    payload.errors = payload.errors.filter((error: { exception?: { message?: string } }) => {
      const message = error?.exception?.message ?? '';
      return !IGNORED_ERROR_MESSAGES.some((pattern) => pattern.test(message));
    });
  }
  return payload;
});

export default apm;
